import { wordCount } from '__core/shared/util/transform';
import { isHomeLoanPreferredProductFixedInterestOnlyLineOfCreditOrInterestInAdvance } from '__core/shared/util/salestrekker';
import template from './homeLoanCompliance.template.html';
import templateAddNewAddress from '../address/addNewAddress.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    validationErrors: '<',
    compliance: '<',
    ticketClientTypes: '<',
    contacts: '<',
    addresses: '<',
    assets: '<',
    homeLoanSecurities: '<',
    fundingWorksheets: '<',
    liabilities: '<',
    compareProducts: '<',
    reviewProducts: '<',
    lenders: '<',
    income: '<',
    expenses: '<',
    countries: '<',
    objectives: '<',
    ticketOwner: '<',
    ticketDescription: '<',
    workflow: '<',
    idTicket: '<',
    showSwitchRefixSection: '<',
    isDealOwnerBroker: '<',
    canSeeNeedsAnalysis: '<',
    isTicketSettled: '<',
    onChanged: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      $timeout,
      eventService,
      helperService,
      homeLoanService,
      financeService,
      financesService,
      HomeLoanCompliance,
      Address,
      YesNoOption,
      ImportantOption,
      dateTimeService,
      GOOGLEMAPS
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = null;
      ctrl.availableStates = [];
      ctrl.simpleSelectOptions = [];
      ctrl.simpleSelectShortOptions = [];
      ctrl.availableYesNoOptionsOne = [];
      ctrl.availableImportantOptionsOne = [];
      ctrl.availableInterviewMethods = [];
      ctrl.availableFeesAndCharges = [];
      ctrl.availableEmploymentVerificationMethods = [];
      ctrl.existingInvestmentProperties = [];
      ctrl.existingOwnerOccupiedProperties = [];
      ctrl.newInvestmentProperties = [];
      ctrl.applicantsAddresses = [];
      ctrl.interviewAddresses = [];
      ctrl.preferredProduct = null;
      ctrl.isMFP = false;
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.simpleSelectOptions = helperService.getSimpleSelectOptions();
        ctrl.simpleSelectShortOptions = helperService.getSimpleSelectOptions(true);
        ctrl.availableInterviewMethods = helperService.getAvailableInterviewMethods();
        ctrl.availableFeesAndCharges = homeLoanService.getAvailableFeesAndCharges();
        ctrl.availableEmploymentVerificationMethods = homeLoanService.getAvailableEmploymentVerificationMethods();
        ctrl.availableYesNoOptionsOne = helperService.getAvailableYesNoOptions({ option: 1 });
        ctrl.availableImportantOptionsOne = helperService.getAvailableImportantOptions({
          option: 1
        });
        ctrl.compliance = ctrl.compliance
          ? HomeLoanCompliance.Build(ctrl.compliance)
          : HomeLoanCompliance.Blank();
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.homeLoanSecurities = ctrl.homeLoanSecurities || [];
        ctrl.numberOfHomeLoanSecurities = ctrl.homeLoanSecurities?.length || 0;
        ctrl.fundingWorksheets = ctrl.fundingWorksheets || {};
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.reviewProducts = ctrl.reviewProducts || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.income = ctrl.income || [];
        ctrl.expenses = _.filter(ctrl.expenses || [], (e) => e?.id && _.isUuid(e?.id));
        ctrl.countries = ctrl.countries || [];
        ctrl.objectives = ctrl.objectives || {};
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.ticketDescription = ctrl.ticketDescription || '';
        ctrl.workflow = ctrl.workflow || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.showSwitchRefixSection = ctrl.showSwitchRefixSection || false;
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.canSeeNeedsAnalysis = ctrl.canSeeNeedsAnalysis || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.haveLendersExisting = ctrl.lenders.length > 0;
        ctrl.preferredProduct = homeLoanService.getPreferredProduct(ctrl.compareProducts);
        ctrl.preferredLender = ctrl.preferredProduct
          ? ctrl.getLender(ctrl.preferredProduct.idLender)
          : null;
        ctrl.existingInvestmentProperties = helperService.getInvestmentAssets({
          assets: ctrl.assets
        });
        if (ctrl.organizationCountry.cca2 === 'NZ') {
          ctrl.existingOwnerOccupiedProperties = helperService.getOwnerOccupiedAssets({
            assets: ctrl.assets
          });
        }
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives,
          'signedDocuments.creditProposalDate',
          'getSetCreditProposalDate'
        );
        ctrl.getAllAddresses();
        if (!ctrl.isTicketSettled) {
          ctrl.isProcessing = true;
          ctrl.financeMonthlyFinancialPositionEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.wordCount = (text) => {
        const s = wordCount(text);
        return s?.length === 1 ? `${s.length} word` : `${s.length || 0} words`;
      };

      ctrl.totalWordCount = () => {
        let allComments = `${
          ctrl.compliance?.comments?.analysisAssessmentAndApplicantEducation || ''
        }
          ${ctrl.compliance?.comments?.optionsPresentedAndRecommendation || ''}
          ${ctrl.compliance?.comments?.borrowingPower || ''}
          ${ctrl.compliance?.comments?.depositOrEquity || ''}
          ${ctrl.compliance?.comments?.security || ''}
          ${ctrl.compliance?.comments?.applicationSubmission || ''}
          ${ctrl.compliance?.comments?.creditHistory || ''}
          ${ctrl.compliance?.comments?.livingExpenses || ''}`;
        if (
          ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance().isInterestOnly
        ) {
          allComments += `${ctrl.compliance?.comments?.interestOnlyProduct || ''}`;
        }
        if (
          ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance()
            .isInterestInAdvance
        ) {
          allComments += `${ctrl.compliance?.comments?.interestInAdvance || ''}`;
        }
        if (ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance().isFixed) {
          allComments += `${ctrl.compliance?.comments?.fixedProduct || ''}`;
        }
        if (
          ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance().isLineOfCredit
        ) {
          allComments += `${ctrl.compliance?.comments?.lineOfCredit || ''}`;
        }
        return wordCount(allComments);
      };

      ctrl.getAllAddresses = () => {
        ctrl.applicantsAddresses = [];
        for (let a = 0; a < ctrl.compliance?.verifications?.applicants?.length; a += 1) {
          const blankApplicantAddress = !ctrl.compliance?.verifications?.applicants[a]?.address
            ?.street
            ? Address.build(ctrl.compliance.verifications.applicants[a].address)
            : Address.blank();
          const allApplicantAddresses = angular.copy(ctrl.addresses);
          allApplicantAddresses.unshift(blankApplicantAddress);
          ctrl.applicantsAddresses.push(_.compact(allApplicantAddresses));
        }
        const blankInterviewAddress = !ctrl.compliance?.verifications?.interviewDetailsLocation
          ?.street
          ? Address.build(ctrl.compliance.verifications.interviewDetailsLocation)
          : Address.blank();
        const allInterviewAddresses = angular.copy(ctrl.addresses);
        allInterviewAddresses.unshift(blankInterviewAddress);
        ctrl.interviewAddresses = _.compact(allInterviewAddresses);
      };

      ctrl.addNewVerificationsAddress = ($event, idx) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              index: idx,
              googleAutocompleteOptions: ctrl.googleAutocompleteOptions,
              availableStates: ctrl.availableStates,
              countries: ctrl.countries
            },
            template: templateAddNewAddress,
            controllerAs: '$ctrl',
            controller(index, googleAutocompleteOptions, availableStates, countries) {
              const ctr = this;
              ctr.idx = index;
              ctr.googleAutocompleteOptions = googleAutocompleteOptions;
              ctr.availableStates = availableStates;
              ctr.countries = countries;
              ctr.address = Address.blank();
              ctr.confirm = () => {
                $mdDialog.hide({ idx: ctr.idx, address: ctr.address });
              };
              ctr.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            if (
              result?.address &&
              result?.address?.streetNumber !== '' &&
              result?.address?.street &&
              (result?.address?.suburb || result?.address?.city) &&
              result?.address?.postCode
            ) {
              if (result.idx !== null) {
                ctrl.compliance.verifications.applicants[idx].address = result.address;
              } else {
                ctrl.compliance.verifications.interviewDetailsLocation = result.address;
              }
              ctrl.addresses.push(result.address);
              ctrl.getAllAddresses();
              ctrl.complianceChanges(true);
            }
          });
      };

      ctrl.addressChanged = () => {
        ctrl.getAllAddresses();
        ctrl.complianceChanges(true);
      };

      ctrl.getAddress = (address) =>
        address?.street ? Address.getAddress(address) : 'Select one';

      ctrl.toggleInterviewDetails = (field) => {
        if (
          field === 'interviewDetailsCustomersSpeakAndUnderstandEnglishFluently' &&
          (ctrl.compliance?.verifications
            ?.interviewDetailsCustomersSpeakAndUnderstandEnglishFluently === '' ||
            ctrl.compliance?.verifications
              ?.interviewDetailsCustomersSpeakAndUnderstandEnglishFluently === 1)
        ) {
          ctrl.compliance.verifications.interviewDetailsInterviewWasConductedInTheFollowingLanguage =
            '';
          ctrl.compliance.verifications.interviewDetailsInterviewIsBrokerFluentInThisLanguage =
            '';
          ctrl.compliance.verifications.interviewDetailsInterviewWasTranslatorUsed = '';
        }
        if (
          field === 'interviewDetailsInterviewWasConductedInTheFollowingLanguage' &&
          ctrl.compliance?.verifications
            ?.interviewDetailsInterviewWasConductedInTheFollowingLanguage === ''
        ) {
          ctrl.compliance.verifications.interviewDetailsInterviewIsBrokerFluentInThisLanguage =
            '';
          ctrl.compliance.verifications.interviewDetailsInterviewWasTranslatorUsed = '';
        }
        if (
          field === 'interviewDetailsInterviewIsBrokerFluentInThisLanguage' &&
          (ctrl.compliance?.verifications
            ?.interviewDetailsInterviewIsBrokerFluentInThisLanguage === '' ||
            ctrl.compliance?.verifications
              ?.interviewDetailsInterviewIsBrokerFluentInThisLanguage === 1)
        ) {
          ctrl.compliance.verifications.interviewDetailsInterviewWasTranslatorUsed = '';
        }
        ctrl.complianceChanges(true);
      };

      ctrl.toggleConflictSuitability = (isConflict) => {
        if (
          isConflict &&
          ctrl.compliance?.interestDisclosure?.isConflict?.name === YesNoOption.no.name
        ) {
          ctrl.compliance.interestDisclosure.comments = '';
          ctrl.compliance.interestDisclosure.lenderConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.lenderConflictOfInterestComments = '';
          ctrl.compliance.interestDisclosure.referralConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.referralConflictOfInterestComments = '';
          ctrl.compliance.interestDisclosure.otherConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.otherConflictOfInterestComments = '';
        } else if (!isConflict && !ctrl.compliance.productSuitability.isUnsuitable) {
          ctrl.compliance.productSuitability.isProductInconsistent = false;
          ctrl.compliance.productSuitability.isApplicantComply = false;
        }
        ctrl.complianceChanges(true);
      };

      ctrl.getContact = (idContact) => _.find(ctrl.contacts || [], (c) => c?.id === idContact);

      ctrl.isSomeRiskBenefitStatementsSelected = () =>
        homeLoanService.isSomeRiskBenefitStatementsSelected(ctrl.compliance);

      ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance = () =>
        isHomeLoanPreferredProductFixedInterestOnlyLineOfCreditOrInterestInAdvance(
          ctrl.reviewProducts
        );

      ctrl.getLender = (idLender) => _.find(ctrl.lenders, (l) => l.id === idLender);

      ctrl.getAnnouncement = () =>
        financeService.getMonthlyFinancialPositionAnnouncement({ workflow: ctrl.workflow });

      ctrl.showCommentsWarning = () => {
        const collection = [];
        collection.push(
          !ctrl.compliance.comments.borrowingPower,
          !ctrl.compliance.comments.depositOrEquity,
          !ctrl.compliance.comments.creditHistory,
          !ctrl.compliance.comments.applicationSubmission,
          !ctrl.compliance.comments.livingExpenses
        );
        if (
          ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance().isInterestOnly
        ) {
          collection.push(!ctrl.compliance.comments.interestOnlyProduct);
        }
        if (
          ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance()
            .isInterestInAdvance
        ) {
          collection.push(!ctrl.compliance.comments.interestInAdvance);
        }
        if (ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance().isFixed) {
          collection.push(!ctrl.compliance.comments.fixedProduct);
        }
        if (
          ctrl.isPreferredProductFixedInterestOnlyLineOfCreditInterestInAdvance().isLineOfCredit
        ) {
          collection.push(!ctrl.compliance.comments.lineOfCredit);
        }
        if (ctrl.organizationCountry.cca2 === 'NZ') {
          collection.push(!ctrl.compliance.comments.security);
        } else {
          collection.push(
            !ctrl.compliance.comments.analysisAssessmentAndApplicantEducation,
            !ctrl.compliance.comments.optionsPresentedAndRecommendation
          );
        }
        return _.some(collection, (c) => c === true);
      };

      ctrl.noneOfConflictOfInterestDisclosureOptionsSelected = () => {
        const collection = [];
        collection.push(
          ctrl.compliance?.interestDisclosure?.lenderConflictOfInterest &&
            ctrl.compliance?.interestDisclosure?.lenderConflictOfInterestComments !== ''
        );
        collection.push(
          ctrl.compliance?.interestDisclosure?.referralConflictOfInterest &&
            ctrl.compliance?.interestDisclosure?.referralConflictOfInterestComments !== ''
        );
        collection.push(
          ctrl.compliance?.interestDisclosure?.otherConflictOfInterest &&
            ctrl.compliance?.interestDisclosure?.otherConflictOfInterestComments !== ''
        );
        return _.every(collection, (c) => c === false);
      };

      ctrl.showConflictOfInterestDisclosureWarning = () =>
        ctrl.compliance?.interestDisclosure?.isConflict?.name === YesNoOption.none.name ||
        (ctrl.compliance?.interestDisclosure?.isConflict?.name === YesNoOption.yes.name &&
          ctrl.noneOfConflictOfInterestDisclosureOptionsSelected());

      ctrl.showProductSuitabilityWarning = () =>
        ctrl.compliance.productSuitability.isUnsuitable === null ||
        (ctrl.compliance.productSuitability.isUnsuitable &&
          !ctrl.compliance.productSuitability.isProductInconsistent &&
          !ctrl.compliance.productSuitability.isApplicantComply);

      ctrl.hasErrorExistForBrokerDisclosureField = ({ field }) => {
        const isLoanWorks = helperService.isLoanworksGatewaySelected({
          idLender: ctrl.preferredLender?.id
        });
        if (ctrl.preferredLender) {
          return isLoanWorks
            ? field?.name !== YesNoOption.yes.name
            : field?.name === YesNoOption.none.name;
        }
        return false;
      };

      ctrl.showBrokerDisclosureWarning = () => {
        const collection = [];
        if (ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.refinance) {
          collection.push(
            ctrl.objectives?.requirementsAndObjectives?.applicantsUnderstandPurposes?.name ===
              YesNoOption.none.name,
            ctrl.objectives?.requirementsAndObjectives
              ?.applicantsUnderstandThatMayEndUpPayMoreInterest?.name === YesNoOption.none.name
          );
        }
        if (ctrl.objectives?.rateType?.fixed?.type?.name === ImportantOption.important.name) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.rateType?.fixed?.isConfirmed
            })
          );
        }
        if (
          ctrl.objectives?.rateType?.variable?.type?.name === ImportantOption.important.name
        ) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.rateType?.variable?.isConfirmed
            })
          );
        }
        if (
          ctrl.objectives?.rateType?.fixedAndVariable?.type?.name ===
          ImportantOption.important.name
        ) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.rateType?.fixedAndVariable?.isConfirmed
            })
          );
        }
        if (
          ctrl.objectives?.repaymentType?.principalAndInterest?.type?.name ===
          ImportantOption.important.name
        ) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.repaymentType?.principalAndInterest?.isConfirmed
            })
          );
        }
        if (
          ctrl.objectives?.repaymentType?.interestOnly?.type?.name ===
          ImportantOption.important.name
        ) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.repaymentType?.interestOnly?.isConfirmed
            })
          );
        }
        if (
          ctrl.objectives?.repaymentType?.interestInAdvance?.type?.name ===
          ImportantOption.important.name
        ) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.repaymentType?.interestInAdvance?.isConfirmed
            })
          );
        }
        if (
          ctrl.objectives?.repaymentType?.lineOfCredit?.type?.name ===
          ImportantOption.important.name
        ) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.repaymentType?.lineOfCredit?.isConfirmed
            })
          );
        }
        if (
          ctrl.objectives?.productType?.offsetAccount?.type?.name ===
          ImportantOption.important.name
        ) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.productType?.offsetAccount?.isConfirmed
            })
          );
        }
        if (
          ctrl.objectives?.productType?.redraw?.type?.name === ImportantOption.important.name
        ) {
          collection.push(
            ctrl.hasErrorExistForBrokerDisclosureField({
              field: ctrl.objectives?.productType?.redraw?.isConfirmed
            })
          );
        }
        collection.push(
          ctrl.objectives?.signedDocuments?.creditProposal?.name === YesNoOption.none.name
        );
        if (ctrl.objectives?.signedDocuments?.creditProposal?.name === YesNoOption.yes.name) {
          collection.push(!ctrl.objectives?.signedDocuments?.creditProposalDate);
        }
        if (ctrl.objectives?.signedDocuments?.creditProposal?.name === YesNoOption.no.name) {
          collection.push(!ctrl.objectives?.signedDocuments?.creditProposalComments);
        }
        if (ctrl.organizationCountry.cca2 !== 'NZ') {
          collection.push(
            ctrl.compliance?.brokerDisclosure?.designDistributionObligations?.name ===
              YesNoOption.none.name
          );
          if (
            ctrl.compliance?.brokerDisclosure?.designDistributionObligations?.name ===
            YesNoOption.no.name
          ) {
            collection.push(
              !ctrl.compliance?.brokerDisclosure?.designDistributionObligationsComments
            );
          }
        }
        if (ctrl.organizationCountry.cca2 === 'NZ') {
          collection.push(
            ctrl.compliance?.brokerDisclosure?.capitalisationOfFees?.name ===
              YesNoOption.none.name
          );
          if (
            ctrl.compliance?.brokerDisclosure?.capitalisationOfFees?.name ===
            YesNoOption.no.name
          ) {
            collection.push(!ctrl.compliance?.brokerDisclosure?.capitalisationOfFeesComments);
          }
        }
        collection.push(
          ctrl.objectives?.conflictsBetweenLoanFeatures?.anyConflictsMarkedAsImportant?.name ===
            YesNoOption.none.name
        );
        if (
          ctrl.objectives?.conflictsBetweenLoanFeatures?.anyConflictsMarkedAsImportant?.name ===
          YesNoOption.yes.name
        ) {
          collection.push(!ctrl.objectives?.conflictsBetweenLoanFeatures?.conflictsComments);
        }
        return _.some(collection, (c) => c === true);
      };

      ctrl.financeMonthlyFinancialPositionEstimate = () => {
        ctrl.isMFP = false;
        financesService
          .monthlyFinancialPosition({ idTicket: ctrl.idTicket || '' })
          .then((res) => {
            if (res?.status && !_.isEmpty(res?.compliance)) {
              ctrl.compliance = HomeLoanCompliance.Build(res?.compliance);
              const data = {
                compliance: ctrl.compliance
              };
              ctrl.onChanged({ data });
            }
            ctrl.isProcessing = false;
          });
      };

      ctrl.complianceChanges = _.debounce((isSilent) => {
        if (!isSilent) {
          ctrl.isMFP = true;
        }
        ctrl.saveHomeLoanCompliance();
      }, 3000);

      ctrl.toggleSignedDocuments = () => {
        ctrl.objectives.signedDocuments.creditProposalDate = 0;
        ctrl.objectives.signedDocuments.creditProposalComments = '';
        // eslint-disable-next-line no-underscore-dangle
        ctrl.__getSetCreditProposalDate = '';
        ctrl.saveHomeLoanCompliance();
      };

      ctrl.toggleBrokerDisclosure = ({ property }) => {
        if (ctrl.compliance?.brokerDisclosure?.[property]?.name === YesNoOption.yes.name) {
          ctrl.compliance.brokerDisclosure[`${property}Comments`] = '';
        }
        ctrl.saveHomeLoanCompliance();
      };

      ctrl.saveHomeLoanCompliance = () => {
        ctrl.compliance.monthlyFinancialPosition.totalWords = ctrl.totalWordCount();
        ctrl.isProcessing = ctrl.isMFP;
        const data = {
          compliance: ctrl.compliance,
          objectives: ctrl.objectives,
          hLCD: ctrl.isMFP ? 'homeLoanCompliance' : ''
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'homeLoanCompliance') {
          ctrl.financeMonthlyFinancialPositionEstimate();
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
